export default () => ({
  id: null,
  amount: null,
  isDefaultAmountLoading: false,
});
